import type { IconSvgObject } from './types';

const ChevronUpIcon: IconSvgObject = [
  ["path", { d: "M6 15L12 9L18 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ChevronUpIcon;
